import React, { FC } from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const ArrowReload = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0371 12H21.9979C21.998 10.8453 21.7915 9.64072 21.2977 8.3997C19.9041 4.89732 16.6391 2.36033 12.8836 2.038C6.59237 1.49802 1.3829 6.78794 2.05923 13.1037C2.55856 17.7669 6.3967 21.5347 11.0675 21.9576C13.7895 22.2041 16.3117 21.3587 18.246 19.8097C18.7096 19.4386 18.7406 18.7406 18.3206 18.3207C17.9606 17.9607 17.3897 17.9287 16.9922 18.247C15.2489 19.6429 12.9109 20.3257 10.4249 19.8486C7.29617 19.2482 4.76974 16.7336 4.1575 13.6072C3.15646 8.49485 7.0632 3.99998 12 3.99998C16.4112 3.99998 20 7.58872 20 12H18.9893C18.5818 12 18.3455 12.4843 18.5836 12.8314L20.6075 15.7818C20.807 16.0727 21.2195 16.0727 21.419 15.7818L23.4429 12.8314C23.6811 12.4843 23.4447 12 23.0371 12Z"
      fill={color}
    />
  </svg>
);
